"use client";

import { useState } from "react";
import { Menu } from "lucide-react";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-z-30 tw-px-4 tw-py-6">
      <div className="tw-max-w-7xl tw-mx-auto tw-flex tw-justify-between tw-items-center">
        <div className="tw-flex tw-items-center">
          <img
            src="/images/sofest-logo.png"
            alt="SoFest Logo"
            style={{ height: "120px", marginRight: "32px" }}
          />
          <div className="tw-hidden md:tw-flex tw-items-center tw-space-x-1 tw-text-white">
            <span className="tw-px-3 tw-py-2 tw-font-bold">
              13TH - 17TH DECEMBER 2025
            </span>
            <span className="tw-px-3 tw-py-2 tw-text-red-500 tw-font-bold">
              —
            </span>
            <span className="tw-px-3 tw-py-2 tw-font-bold">BEIJING</span>
          </div>
        </div>

        <div className="tw-hidden md:tw-flex tw-items-center tw-space-x-4 tw-text-white">
          <a
            href="#explore"
            className="tw-px-3 tw-py-2 hover:tw-text-red-500 tw-transition-colors tw-font-bold"
          >
            EXPLORE
          </a>

          <button
            onClick={() =>
              window.open("https://sotravel.com/trip/1948", "_blank")
            }
            className="tw-bg-red-500 tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-rounded-md hover:tw-bg-red-600 tw-transition-colors"
          >
            WAITLIST NOW
          </button>
        </div>

        <button
          className="md:tw-hidden tw-text-white"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <Menu size={24} />
        </button>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:tw-hidden tw-bg-black tw-bg-opacity-90 tw-mt-4 tw-rounded-md tw-p-4 tw-text-white">
          <div className="tw-flex tw-flex-col tw-space-y-3">
            <a
              href="#explore"
              className="tw-px-3 tw-py-2 hover:tw-text-red-500 tw-transition-colors"
            >
              EXPLORE
            </a>
            <a
              href="#plan"
              className="tw-px-3 tw-py-2 hover:tw-text-red-500 tw-transition-colors"
            >
              PLAN
            </a>
            <button className="tw-bg-red-500 tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-rounded-md hover:tw-bg-red-600 tw-transition-colors tw-mt-2">
              BOOK NOW
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
